// export const host = "http://localhost:4000";
export const host = "https://academiahubs.netlify.app";
// For Authentication
export const authentication = "api/auth";
// utils/axiosInstance.js


